<template>
  <div>
    <div style="display: flex; justify-content: space-between;">
      <div>
        <button class="blue-button" @click="makeCall">
  <i class="feather icon-phone-call mr-2" style="color: white;"></i>اتصال
</button>
        <button class="green-button" @click="openWhatsApp(PropertyData.Broker.Phone)">
          <i class="feather icon-message-circle mr-2" style="color: white;"></i>واتساب
        </button>
      </div>
      <div style="text-align: right;">
        <div style="font-weight: bold; font-size: 20px;">{{ PropertyData.Price }} ريال سعودى </div>
        
      </div>
    </div>
    <div class="app">
      <carousel>
        <carousel-slide v-for="slide in filteredSlides" :key="slide.Id" class="carousel-slider">
          <div class="image-container">
            <img v-if="slide.AttachmentTypeID==2" :src="baseURL +'/'+ slide.UrlAttachment" :alt="slide" style="width: 100%; height: 100%;">
          </div>
        </carousel-slide>
      </carousel>
    </div>
    

    
    <div style="text-align: left; direction: rtl;">
      <div style="display: flex; justify-content: right;">
      <ul style="list-style-type: none; direction: rtl;">
        <h1 style="direction: rtl;">{{ PropertyData.NameAR }}</h1>
        <li>{{ PropertyData.DescraptionAr }}</li>
      </ul>
      </div>
    <h2 style="text-align: center; margin-right: 50px">تفاصيل الاعلان</h2>
    <table class="table table-striped">
  <tr>
    <td>
    
        
        <tr>
          <td >عدد الغرف</td>
          <td >{{ PropertyData.BedroomCount }} غرف</td>
        </tr>
        <tr>
          <td>عدد الحمامات</td>
          <td>{{ PropertyData.BathroomCount }} حمام</td>
        </tr>
        
      
    </td>
    <td style="width: 20px;"></td> <!-- Space between tables -->
    <td >
        <tr>
          <td>العنوان</td>
          <td>{{ PropertyData.AdressAR }}</td>
        </tr>
        <tr>
          <td> المساحه</td>
          <td>{{ PropertyData.Size }} متر</td>
        </tr>
        <tr>
          <td>سنه البناء</td>
          <td> {{ PropertyData.YearBuild }}</td>
        </tr>
    
    </td>
    <td style="width: 20px;"></td> <!-- Space between tables -->
    <td >
        <tr>
          <td> السعر</td>
          <td>{{ PropertyData.PriceSR }}ريال سعودى</td>
        </tr>
        <tr>
          <td>عدد الجاراج</td>
          <td>{{ PropertyData.GarageCount }}</td>
        </tr>
    </td>
  </tr>
</table>

    </div>
    <div style="margin-top: 20px;">
    <h2 style="text-align: center;">وصف الاعلان</h2>
    <div>
      <p>
        {{ PropertyData.DescraptionAr }}
      </p>
    </div>
  </div>
  <div style="margin-top: 20px;">
    <h2 style="text-align: center;">الموقع علي الخريطه</h2>
    <div >
      <iframe  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13804.470248714215!2d31.3427151!3d30.1194493!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x145815f5f948bedd%3A0x919910ec5fe86f54!2z2YPZiNmG2YPZiNix2K8g2KfZhNiz2YTYp9mFINin2YTZgtin2YfYsdipINmF2YYg2LHZiNmK2KfZhCDYqtmI2YTZitio!5e0!3m2!1sar!2seg!4v1715425333038!5m2!1sar!2seg" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

    </div>
  </div>
  
  </div>
</template>
<script>
import { domain } from "@/gloabelConstant.js";
import Carousel from './Carousel.vue';
import CarouselSlide from './CarouselSlide';
import moduleProperty from "@/store/Property/moduleProperty.js";
export default {
  components: {
   Carousel : Carousel,
   CarouselSlide : CarouselSlide,
   //VxCard
  },
  data() {
    return {
      baseURL: domain,}
    },
  computed: {
    filteredSlides() {
      debugger;
      return this.PropertyData.CustomerPropertyAttachments.filter(slide => slide.AttachmentTypeID == 2);
    },
    PropertyImagesSliders() {
        debugger;
        return this.$store.state. PropertyList.PropertyImagesSlidersList;
      },
      PropertyData() {
      debugger;
      var x=this.$store.state.PropertyList.Property;
      return x;
  },
},
    methods:{
      openConfirm() {
      
        this.$vs.dialog({
          type: "confirm",
      color: "success",
      title: this.$t("Confirm"),
       text: this.$t("Areyousureyouwanttoaccepttheisrequest"),
       accept: this.approvedsuccess,
      acceptText: this.$t("Confirm"),
      cancelText: this.$t("Cancel"),
        });
      },
      makeCall() {
    const phoneNumber = '201091041238'; // Replace with the client's phone number
    window.location.href = `tel:${phoneNumber}`;
  },
      openWhatsApp(phoneNumber) {
        debugger;
        console.log(phoneNumber);
  //const phoneNumber = '966331766152'; // Phone number with no spaces or special characters
  const message = encodeURIComponent('Hello, I would like to contact you!');
  const url = `https://wa.me/${phoneNumber}?text=${message}`;
  window.location.href = url;
},

      openConfirmDanger() {
      
      this.$vs.dialog({
        type: "confirm",
    color: "red",
    title: this.$t("Confirm"),
     text: this.$t("AreyousureyouwanttoDenytheisrequest"),
     accept: this.approvedsuccess,
    acceptText: this.$t("Confirm"),
    cancelText: this.$t("Cancel"),
      });
    },
    },
    created() {
    if (!moduleProperty.isRegistered) {
      this.$store.registerModule("PropertyList", moduleProperty);
      moduleProperty.isRegistered = true;
    }
    debugger;
    var x=this.$route.params.Id;
    
    this.$store.dispatch("PropertyList/GetItemByID",x);
    //this.GetCountries();

  },
  mounted() {
    this.isMounted = true;
    //this.GetCountries();
  }
  }

</script>

<style scoped>
.blue-button {
  background-color: blue;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
}

.green-button {
  background-color: green;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
}
.table {
    border-collapse: collapse;
    width: 100%;
  }

  .table td, .table th {
    border: 1px solid #dddddd;
    padding: 8px;
    text-align: left;
  }

  .table th {
    background-color: #f2f2f2;
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: #f9f9f9;
  }
</style>